import { BrokenTeethIcon, SuccessIcon } from "../../Icons/Icons";
import { Button } from "@mui/material";

type UploadMsgProps = {
  msgType: "success" | "error";
  message?: string;
  onClickForward?: () => void;
  onClickBack?: () => void;
};

const UploadMessages = (props: UploadMsgProps) => {
  const {
    msgType,
    message = "Successfully uploaded!",
    onClickForward,
    onClickBack,
  } = props;
  const successMessage = (
    <>
      <div className="row icon">
        <SuccessIcon />
      </div>
      <div className="row">
        <h2>{message}</h2>
        {onClickForward && (
          <Button className="btn btn-outlined" onClick={onClickForward}>
            Continue to upload
          </Button>
        )}
      </div>
    </>
  );

  const errorMessage = (
    <>
      <div className="row icon">
        <BrokenTeethIcon />
      </div>
      <div className="row">
        <h2>{message || "Oops, something went wrong..."}</h2>
        {onClickBack && (
          <Button className="btn btn-outlined" onClick={onClickBack}>
            Back
          </Button>
        )}
      </div>
    </>
  );
  return msgType ? (
    <div className="msg-upload-wrapper">
      {msgType === "success" && successMessage}
      {msgType === "error" && errorMessage}
    </div>
  ) : null;
};

export default UploadMessages;
